module.exports = __webpack_public_path__ + "static/ubuntu-regular-1e926e228a9e2e1e77034f624211e2b4.woff";